import type { Message } from 'shared/domain/messages/message';
import type { ChannelMessageHandler } from './types';

/**
 * Delivers a message to every handler. A failing handler is reported and does
 * not prevent the remaining handlers from receiving the message.
 */
export function deliverChannelMessage(
  handlers: Iterable<ChannelMessageHandler>,
  event: Message,
  onHandlerError: (error: unknown) => void
): void {
  // Copy first: a handler may unsubscribe (or subscribe) while being called.
  for (const handler of [...handlers]) {
    try {
      handler(event);
    } catch (error) {
      onHandlerError(error);
    }
  }
}
